import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface StaffEventSelectedTabState {
  selectedTab: number;
}

const initialState: StaffEventSelectedTabState = {
  selectedTab: 0,
};

export const staffEventSelectedTabSlice = createSlice({
  name: "staffEventSelectedTab",
  initialState,
  reducers: {
    setStaffSelectedTab: (state, action: PayloadAction<number>) => {
      state.selectedTab = action.payload;
    },
    resetStaffSelectedTab: (state) => {
      state.selectedTab = 0;
    },
  },
});

export const { setStaffSelectedTab, resetStaffSelectedTab } = staffEventSelectedTabSlice.actions;
export default staffEventSelectedTabSlice.reducer;

